import NewLayout from "@components/new-ui/Layout";
import { AppButton } from "@components/Typography";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Image from "next/image";
import React, { FC, ReactElement } from "react";
import { FaLinkedinIn, FaTwitter } from "react-icons/fa";
/**
 * @deprecated The method should not be used
 */
const AboutRevamp: FC = () => {
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [loaded, setLoaded] = React.useState(false);
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    const FOUNDERS = [
        {
            id: 1111,
            name: "Karthik Jagannathan",
            position: "CEO & Co-founder",
            socialLink: {
                linkedIn: "https://www.linkedin.com/in/jkarthik",
                twitter: "https://twitter.com/karthikj",
            },
            image: "/about-revamap/karthik.webp",
        },
        {
            id: 2222,
            name: "Yogesh Narayanan",
            position: "CTO & Co-founder",
            socialLink: {
                linkedIn: "https://www.linkedin.com/in/yogeshnarayanan",
                twitter: "https://twitter.com/yogeshnarayanan",
            },
            image: "/about-revamap/yogesh.webp",
        },
        {
            id: 333,
            name: "Yathindhar Panchanathan",
            position: "CPO & Co-founder",
            socialLink: {
                linkedIn: "https://www.linkedin.com/in/yathin",
                twitter: "https://twitter.com/YathinVP",
            },
            image: "/about-revamap/panchanatham.webp",
        },
    ];
    const ABOUTUS = [
        {
            title: "Customer-first",
            content: "We exist to grow our customer’s business",
            image: "/about-revamap/customer-first.svg",
        },
        {
            title: "Raise standards",
            content: " Always curious to know more, and hungry to better our best performance ",
            image: "/about-revamap/rise-standard.svg",
        },
        {
            title: "Simple is beautiful",
            content: "Work hard to make our products simple and a delight to use",
            image: "/about-revamap/simple.svg",
        },
        {
            title: "Nurture talent",
            content: "Embrace diversity of people and ideas; respect and rely on each other",
            image: "/about-revamap/nurture.svg",
        },
        {
            title: "Work fast to completion",
            content: "Be nimble-footed, execute fast, do it well, and stay focused till it’s done",
            image: "/about-revamap/work-fast.svg",
        },
        {
            title: "Integrity",
            content: "Own the cause, take responsibility for decisions and actions",
            image: "/about-revamap/integrity.svg",
        },
    ];

    const sliderContent = ["slider-1.webp", "slider-2.webp", "slider-3.webp", "slider-4.webp", "slider-5.webp"];

    return (
        <NewLayout
            keywords="about gallabox, team gallabox, careers at gallabox"
            title="About Gallabox | India's Favourite WhatsApp Solution Provider"
            description="Gallabox empowers businesses to acquire, engage and retain customers with a No-code solution through WhatsApp Business APIs"
        >
            <div className="about-page  md:mt-16">
                <header className="relative md:pt-7">
                    <h1 className="m-0 px-6 md:px-0 md:w-3/5 mx-auto py-7">We are on a mission to help businesses grow their sales with Conversational Commerce tools</h1>
                    <div className="md:w-5/6 max-w-7xl mx-auto md:py-16">
                        <div className="flex flex-col-reverse md:flex-row">
                            <div className="px-6 md:px-0 py-6 md:py-0 md:pr-20">
                                <p className="header-content">
                                    <span style={{ color: "#0083FF" }}>We believe in the power of conversations.</span> Conversations are key for building customer relationships,
                                    especially when converting a prospect to sales.
                                </p>
                                <p className="header-content">
                                    Sales is the oxygen for businesses. While enterprises have the resources to build bespoke tools to interact and transact with their customers,
                                    small and medium-sized businesses do not have this expertise.
                                </p>
                                <p className="header-content">
                                    Gallabox makes it easy for such businesses to automate their customer interactions to turn conversations to transactions.
                                </p>
                            </div>
                            <div>
                                <div className="header-image">
                                    <Image width={630} height={400} src="https://assets.gallabox.com/gb-home/group_photo.jpg" alt="hero image" className="object-contain" />
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <section>
                    <p className="small-head-text">CORE VALUES</p>
                    <h2 className="sub-head-text px-2 md:px-0" style={{ color: "#1D2D61" }}>
                        Who we are and how we do things
                    </h2>
                    <div className="md:w-5/6 max-w-7xl mx-auto py-7 md:py-20">
                        <div className="md:flex">
                            <div className="w-11/12 pb-4 pl-6 md:pl-0 md:w-full md:grid md:grid-cols-2 md:gap-3 md:mr-5">
                                {ABOUTUS.map((each) => (
                                    <div key={each.title} className="flex gap-2 mb-6 md:mb-0">
                                        <div className="" style={{ width: "50px", height: "50px" }}>
                                            <img src={`https://assets.gallabox.com/gb-home${each.image}`} alt={each.title} />
                                        </div>
                                        <div style={{ width: "250px" }}>
                                            <p className="each-value-title">{each.title}</p>
                                            <p className="each-value-content">{each.content}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="">
                                <div className="app-slider about-slider mx-auto">
                                    <div ref={sliderRef} className="keen-slider">
                                        {sliderContent.map((each, i) => (
                                            <div key={i} className={`keen-slider__slide number-slide${i + 1}`} style={{ borderRadius: "20px" }}>
                                                <img src={`https://assets.gallabox.com/gb-home/about-revamap/${each}`} alt="" loading="lazy" />
                                            </div>
                                        ))}
                                    </div>
                                    {loaded && instanceRef.current && (
                                        <div className="dots">
                                            {[...Array(instanceRef.current.track.details.slides.length).keys()].map((idx) => {
                                                return (
                                                    <button
                                                        key={idx}
                                                        onClick={() => {
                                                            instanceRef.current?.moveToIdx(idx);
                                                        }}
                                                        className={"dot" + (currentSlide === idx ? " active" : "")}
                                                    ></button>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ---founder section ----- */}
                <div style={{ backgroundColor: "#171923" }} className=" mt-10 md:mt-0 pt-16 md:pt-24 pb-40">
                    <p className="small-head-text">FOUNDERS</p>
                    <h2 className="sub-head-text m-0 mt-2 md:mt-4" style={{ color: "#fff" }}>
                        Meet the founders
                    </h2>
                    <div className="md:w-5/6 max-w-7xl mx-auto mt-10">
                        <div className="md:flex justify-around">
                            {FOUNDERS.map((each) => (
                                <article key={each.id} className="founder-card mt-10 md:mt-0 mx-auto">
                                    <div className="founder-image">
                                        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                                        {/* @ts-ignore */}
                                        <img src={`https://assets.gallabox.com/gb-home${each.image}`} alt={each.name} loading="lazy" />
                                    </div>
                                    <div>
                                        <h3 className="founder-name">{each.name}</h3>
                                        <p className="founder-position">{each.position}</p>
                                        <div className="flex justify-center">
                                            <div className="flex py-4">
                                                <SocialCTA icon={<FaLinkedinIn />} href={each.socialLink.linkedIn} brandColor="#0077B7" />
                                                <SocialCTA icon={<FaTwitter />} href={each.socialLink.twitter} brandColor="#1DA1F2" />
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="cta-section md:w-5/6 max-w-7xl  relative bottom-32 md:bottom-16 p-6 md:flex items-center  justify-around w-11/12 md:w-full mx-auto md:mb-14">
                    <div>
                        <h3 className="m-0">Ready to transform customer conversations for fast-growing businesses?</h3>
                        <p className="md:w-3/4 mt-2">If you are passionate about growing sales for small and medium-sized businesses at scale, come join us.</p>
                    </div>
                    <div className="py-5">
                        <AppButton buttonText={"Join our team"} href="https://angel.co/company/gallabox/jobs" />
                    </div>
                </div>
            </div>
        </NewLayout>
    );
};

interface SocialCTAProps {
    brandColor: string;
    href: string;
    icon: ReactElement;
}

const SocialCTA: FC<SocialCTAProps> = (props) => {
    const { href, brandColor, icon } = props;
    return (
        <a href={href} target="_blank" rel="noreferrer" className="p-2 text-sm rounded-full transition ease-linear duration-100">
            {icon}
            <style jsx>{`
                color: #fff;
                border: 1px solid #fff;
                :hover {
                    color: #fff;
                    border: 1px solid ${brandColor};
                    background-color: ${brandColor};
                }
                margin-right: 8px;
            `}</style>
        </a>
    );
};

export default AboutRevamp;
